import ReactDOM from 'react-dom';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider as ReduxProvider } from 'react-redux';

import Browser from './browser';
import { cleanUp } from './functions';
import PrintPage from '../../components/Print';

import { store } from '../../modules/stores';
import { StyleSheetManager } from 'styled-components';

const Print = {
  send: (params, printFrame) => {
    // Append iframe element to document body
    document.getElementsByTagName('body')[0].appendChild(printFrame);

    // Get iframe element
    const iframeElement = document.getElementById(params.frameId);

    // Wait for iframe to load all content
    iframeElement.onload = () => {
      // if (params.type === 'pdf') {
      //   performPrint(iframeElement, params);
      //   return;
      // }

      // Get iframe element document
      let printDocument = iframeElement.contentWindow || iframeElement.contentDocument;
      if (printDocument.document) printDocument = printDocument.document;

      const styleEl = printDocument.createElement('style');
      styleEl.type = 'text/css';
      printDocument.head.appendChild(styleEl);

      const pandaStyleInjection = printDocument.createElement('style');
      getPandaStyleInjection(pandaStyleInjection);

      printDocument.head.appendChild(pandaStyleInjection);

      renderShadowRecords(printDocument.body, styleEl, params.config.isCurrentRecord);
      // Append printable element to the iframe body
      // printDocument.body.appendChild(params.printableElement);
      printDocument.body.style.margin = 0;
      printDocument.body.style.padding = 0;

      // Add custom style
      if (params.type !== 'pdf' && params.style) {
        // Create style element
        const style = document.createElement('style');
        style.innerHTML = params.style;

        // Append style element to iframe's head
        printDocument.head.appendChild(style);
      }

      // If printing images, wait for them to load inside the iframe
      const images = printDocument.getElementsByTagName('img');

      if (images.length > 0) {
        loadIframeImages(images).then(() => performPrint(iframeElement, params));
      } else {
        performPrint(iframeElement, params);
      }
    };
  },
};

const renderShadowRecords = (element, styleEl, isCurrentRecord) => {
  ReactDOM.render(
    <ReduxProvider store={store}>
      <IntlProvider locale="en" messages={{}} textComponent="span">
        <StyleSheetManager target={styleEl}>
          <PrintPage isCurrentRecord={isCurrentRecord} />
        </StyleSheetManager>
      </IntlProvider>
    </ReduxProvider>,
    element,
  );
};

function performPrint(iframeElement, params) {
  try {
    window.testElement = iframeElement;
    iframeElement.focus();

    // If Edge or IE, try catch with execCommand
    if (Browser.isEdge() || Browser.isIE()) {
      try {
        iframeElement.contentWindow.document.execCommand('print', false, null);
      } catch (e) {
        iframeElement.contentWindow.print();
      }
    } else {
      // Other browsers
      iframeElement.contentWindow.print();
    }
  } catch (error) {
    params.onError(error);
  } finally {
    cleanUp(params);
  }
}

function loadIframeImages(images) {
  const promises = [];

  for (let image of images) {
    promises.push(loadIframeImage(image));
  }

  return Promise.all(promises);
}

function loadIframeImage(image) {
  return new Promise((resolve) => {
    const pollImage = () => {
      !image ||
      typeof image.naturalWidth === 'undefined' ||
      image.naturalWidth === 0 ||
      !image.complete
        ? setTimeout(pollImage, 500)
        : resolve();
    };
    pollImage();
  });
}

const getPandaStyleInjection = (injectionEl) => {
  injectionEl.type = 'text/css';
  injectionEl.innerHTML = `
  body {
    margin: 0;
    font-family: 'Arial', 'PingFang SC', 'Microsoft Yahei', 'Roboto', sans-serif;
    -webkit-print-color-adjust: exact !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  img {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  input {
    font-family: 'SF Pro text', 'PingFang SC', 'Microsoft Yahei', 'Roboto', sans-serif;
  }
  textarea,
  button {
    font-family: 'SF Pro text', 'PingFang SC', 'Microsoft Yahei', 'Roboto', sans-serif;
  }
  button {
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
  }
  h1,
  h2,
  h3,
  h4,
  p,
  span {
    margin: 0;
  }


  .panda-pill {
    box-sizing: border-box;
    height: 24px;
    border-radius: 12px;
    min-width: 24px;
    max-width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0px 10px;
    flex-shrink: 0;
  }
  .panda-pill,
  .panda-pill span {
    color: #ffffff;
    font-size: 10px;
    font-weight: 400;
  }

  .panda-pill-jar {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
  }
  .panda-pill--margin {
    margin: 3px 5px 3px 0;
  }

  .panda-pill-upright {
    border-radius: 8px;
    content: ' ';
    height: 100%;
    width: 8px;
  }

  .hover-cursor:hover {
    cursor: pointer;
  }

  .flex-align {
    align-items: center;
    display: flex;
  }
  .flex-center {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .flex-1 {
    flex: 1;
  }

  .space-left-small {
    margin-left: 5px;
  }
  .space-left-medium {
    margin-left: 12px;
  }
  .space-left-large {
    margin-left: 20px;
  }
  .space-right-small {
    margin-right: 5px;
  }
  .space-right-medium {
    margin-right: 12px;
  }
  .space-right-large {
    margin-right: 20px;
  }
  .space-bottom-small {
    margin-bottom: 5px;
  }
  .space-bottom-medium {
    margin-bottom: 12px;
  }
  .space-bottom-large {
    margin-bottom: 20px;
  }

  .block-space-bottom {
    display: block;
    margin-bottom: 20px;
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .absolute-stretch {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
  }
  `;
};

export default Print;
